import { render, staticRenderFns } from "./aboutuscontact.vue?vue&type=template&id=42b3ba17&scoped=true&"
import script from "./aboutuscontact.vue?vue&type=script&lang=js&"
export * from "./aboutuscontact.vue?vue&type=script&lang=js&"
import style0 from "./aboutuscontact.vue?vue&type=style&index=0&id=42b3ba17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3ba17",
  null
  
)

export default component.exports